import { HorizontalBar } from 'vue-chartjs'
import barMixin from "./bar-mixin";

export default {
  name    : "chart--bar-horizontal",
  extends : HorizontalBar,
  mixins: [barMixin]
}

